<template>
  <component
    :is="buttonComponent"
    :class="buttonClasses"
    :href="buttonKind === 'email' ? emailHref : undefined"
    @click.prevent="handleShare"
    type="button"
  >
    <template v-if="buttonKind !== 'email' || !isCopied">
      <div class="share-component__svg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="106"
          height="36"
          viewBox="0 0 106 36"
          fill="none"
        >
          <path
            d="M87.9515 1H18.0485C8.63289 1 1 8.63069 1 18.0436C1 27.4566 8.63289 35.0873 18.0485 35.0873H87.9515C97.3671 35.0873 105 27.4566 105 18.0436C105 8.63069 97.3671 1 87.9515 1Z"
            fill="#DDEAE9"
            stroke="#224A4A"
            stroke-miterlimit="10"
          />
          <path
            d="M32.5826 14.0809C33.6999 14.0809 34.6056 13.1751 34.6056 12.0578C34.6056 10.9405 33.6999 10.0348 32.5826 10.0348C31.4653 10.0348 30.5596 10.9405 30.5596 12.0578C30.5596 13.1751 31.4653 14.0809 32.5826 14.0809Z"
            stroke="#224A4A"
            stroke-miterlimit="10"
          />
          <path
            d="M32.5826 26.0521C33.6999 26.0521 34.6056 25.1463 34.6056 24.029C34.6056 22.9117 33.6999 22.006 32.5826 22.006C31.4653 22.006 30.5596 22.9117 30.5596 24.029C30.5596 25.1463 31.4653 26.0521 32.5826 26.0521Z"
            stroke="#224A4A"
            stroke-miterlimit="10"
          />
          <path
            d="M20.5527 18.0386L31.0706 12.8042"
            stroke="#224A4A"
            stroke-miterlimit="10"
          />
          <path
            d="M20.5527 18.0387L31.0706 23.2829"
            stroke="#224A4A"
            stroke-miterlimit="10"
          />
          <path
            d="M20.5531 20.5529C21.9416 20.5529 23.0672 19.4273 23.0672 18.0388C23.0672 16.6504 21.9416 15.5248 20.5531 15.5248C19.1646 15.5248 18.0391 16.6504 18.0391 18.0388C18.0391 19.4273 19.1646 20.5529 20.5531 20.5529Z"
            fill="#224A4A"
          />
          <path
            d="M44.9082 23.7053V22.026C45.8706 22.4581 47 22.7625 48.2668 22.7625C49.8578 22.7625 50.555 22.1143 50.555 21.0341C50.555 20.0422 50.1131 19.669 48.7972 19.2369L47.6678 18.8735C45.9786 18.3432 44.9966 17.4888 44.9966 15.5149C44.9966 13.541 46.3027 12.1759 48.9346 12.1759C50.4863 12.1759 51.3309 12.4803 51.9987 12.8044V14.4837C51.2621 14.1793 50.2899 13.8847 48.9837 13.8847C47.6776 13.8847 47.0294 14.3954 47.0294 15.3578C47.0294 16.3202 47.4026 16.6934 48.5713 17.0666L49.7007 17.4299C51.5469 17.9897 52.6468 18.7459 52.6468 20.8377C52.6468 23.0669 51.3112 24.4615 48.4338 24.4615C46.892 24.4615 45.7135 24.1374 44.9082 23.6955V23.7053Z"
            fill="#224A4A"
          />
          <path
            d="M54.876 11.6061H56.8303V16.1039H56.9187C57.6356 15.5736 58.6765 15.2004 59.7764 15.2004C61.5049 15.2004 62.3789 15.9173 62.3789 17.6457V24.255H60.4246V18.1073C60.4246 17.2038 60.1005 16.8208 58.8828 16.8208C58.1953 16.8208 57.39 17.0565 56.8303 17.3217V24.255H54.876V11.6061Z"
            fill="#224A4A"
          />
          <path
            d="M64.4121 21.8982C64.4121 20.2582 65.4924 19.4823 67.2503 19.2663L69.3715 18.9913V18.3039C69.3715 17.1254 68.8412 16.8111 67.3386 16.8111C66.4646 16.8111 65.7084 16.9486 65.1487 17.0665V15.7014C65.9834 15.3773 66.9262 15.2006 68.0948 15.2006C70.1277 15.2006 71.3258 16.0059 71.3258 17.8521V24.2551H69.7349L69.5679 23.5382H69.4697C69.0572 24.0391 68.3207 24.4319 67.1815 24.4319C65.5709 24.4319 64.4219 23.607 64.4219 21.8982H64.4121ZM69.3715 22.5071V20.2778L67.6922 20.4448C66.7887 20.543 66.3566 20.9063 66.3566 21.7804C66.3566 22.6544 66.9262 23.0276 67.7413 23.0276C68.4091 23.0276 69.0376 22.8017 69.3715 22.4973V22.5071Z"
            fill="#224A4A"
          />
          <path
            d="M73.9082 15.3773H75.7938V16.3888H75.8821C76.3634 15.7701 77.2668 15.2791 78.2096 15.2791C78.4453 15.2791 78.6712 15.3085 78.7596 15.3674V17.0762C78.5533 17.0468 78.2489 17.0271 78.0623 17.0271C77.257 17.0271 76.4517 17.2628 75.8723 17.6262V24.2649H73.918V15.3871L73.9082 15.3773Z"
            fill="#224A4A"
          />
          <path
            d="M80.1543 19.9243V19.6886C80.1543 16.6933 81.9711 15.2006 84.2102 15.2006C86.8126 15.2006 87.9617 16.6933 87.9617 19.5118V20.3662H82.1773C82.3148 22.2321 83.2576 22.8508 84.9369 22.8508C86.1056 22.8508 86.901 22.5955 87.6769 22.2223V23.5873C87.0975 23.9802 86.0663 24.4221 84.5441 24.4221C81.6372 24.4221 80.1641 22.7231 80.1641 19.9243H80.1543ZM82.1675 18.9717H85.9681C85.9681 17.312 85.3494 16.6638 84.1709 16.6638C83.2674 16.6638 82.305 17.145 82.1675 18.9717Z"
            fill="#224A4A"
          />
        </svg>
      </div>
    </template>
    <template v-else>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        class="icon"
      >
        <path
          d="M20 6L9 17L4 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>Link copied</span>
    </template>
  </component>
</template>

<script setup>
import { computed, ref, onMounted, onBeforeUnmount, watch } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "small",
  },
  pageId: {
    type: String,
    required: true,
  },
  blockId: {
    type: String,
    default: undefined,
  },
  webTitle: {
    type: String,
    required: true,
  },
  format: {
    type: Object,
    required: true,
    default: () => ({
      design: "default",
    }),
  },
  context: {
    type: String,
    validator: (value) =>
      ["ArticleMeta", "LiveBlock", "SubMeta"].includes(value),
    required: true,
  },
});

// State
const buttonKind = ref("email");
const isCopied = ref(false);
const isDesktop = ref(false);

// Media query for desktop
const desktopMediaQuery = ref(null);

// Component lifecycle
onMounted(() => {
  checkFeatureSupport();
  desktopMediaQuery.value = window.matchMedia("(min-width: 980px)");
  isDesktop.value = desktopMediaQuery.value.matches;

  // Set up event listener for media query changes
  const handleMediaQueryChange = (e) => {
    isDesktop.value = e.matches;
  };

  desktopMediaQuery.value.addEventListener("change", handleMediaQueryChange);

  // Clean up function
  onBeforeUnmount(() => {
    desktopMediaQuery.value.removeEventListener(
      "change",
      handleMediaQueryChange
    );
  });
});

// Computed properties
const shareData = computed(() => ({
  title: props.webTitle,
  text: props.webTitle,
  url: getUrl(props.pageId, props.blockId),
}));

const isLiveBlogMeta = computed(
  () => props.format?.design === "LiveBlog" && props.context === "ArticleMeta"
);

const isLiveBlogBlockDesktop = computed(
  () => isDesktop.value && props.context === "LiveBlock"
);

const sizeXSmall = computed(() => props.size === "xsmall");

const buttonComponent = computed(() =>
  buttonKind.value === "email" ? "a" : "button"
);

const buttonClasses = computed(() => {
  return {
    "share-button": true,
    "share-button--xsmall": sizeXSmall.value,
    "share-button--copied": isCopied.value,
    "share-button--liveblog-meta": isLiveBlogMeta.value,
  };
});

const emailHref = computed(
  () =>
    `mailto:?subject=${encodeURIComponent(
      props.webTitle
    )}&body=${encodeURIComponent(getUrl(props.pageId, props.blockId))}`
);

// Methods
function getUrl(pageId, blockId) {
  const searchParams = new URLSearchParams({});
  searchParams.append("CMP", "share_btn_url");
  if (blockId) searchParams.append("page", `with:block-${blockId}`);

  // Use the full URL if it's already a complete URL, otherwise construct it
  if (
    pageId &&
    (pageId.startsWith("http://") || pageId.startsWith("https://"))
  ) {
    // Add search params to existing URL
    const url = new URL(pageId);
    url.searchParams.append("CMP", "share_btn_url");
    if (blockId) url.searchParams.append("page", `with:block-${blockId}`);
    if (blockId) url.hash = `block-${blockId}`;
    return url.href;
  } else {
    // Use current page path if pageId is undefined or empty
    const path = pageId ? pageId : window.location.pathname;
    const blockHash = blockId ? `#block-${blockId}` : "";
    const paramsString = searchParams.toString();
    return new URL(
      `${path}${paramsString ? "?" + paramsString : ""}${blockHash}`,
      "https://www.theguardian.com/"
    ).href;
  }
}

function checkFeatureSupport() {
  console.log("Checking feature support...");
  if (
    !isLiveBlogBlockDesktop.value &&
    "share" in navigator &&
    "canShare" in navigator &&
    navigator.canShare(shareData.value)
  ) {
    console.log("Using native share");
    buttonKind.value = "native";
  } else if ("clipboard" in navigator) {
    console.log("Using copy to clipboard");
    buttonKind.value = "copy";
  } else {
    console.log("Using email share");
    buttonKind.value = "email";
  }
}

function handleShare() {
  console.log("Share button clicked, buttonKind:", buttonKind.value);
  if (buttonKind.value === "native") {
    navigator.share(shareData.value).catch((error) => {
      // Ignore the AbortError as it's just a user cancellation
      if (error.name !== "AbortError") {
        console.error("Share failed:", error);
      }
    });
  } else if (buttonKind.value === "copy") {
    navigator.clipboard
      .writeText(getUrl(props.pageId, props.blockId))
      .then(() => {
        console.log("Link copied to clipboard");
        isCopied.value = true;
      })
      .catch(console.error);
  }
}

// Watch for changes that would affect button type
watch([shareData, isLiveBlogBlockDesktop], () => {
  checkFeatureSupport();
});

// Reset copied state after delay
watch(isCopied, (newValue) => {
  if (newValue) {
    const timer = setTimeout(() => {
      isCopied.value = false;
    }, 3000);

    onBeforeUnmount(() => {
      clearTimeout(timer);
    });
  }
});

// Add a watch to log when buttonKind changes
watch(buttonKind, (newValue) => {
  console.log("buttonKind changed to:", newValue);
});
</script>

<style scoped>
.share-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: none;
  border: 1px solid var(--share-button-border);
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  text-decoration: none;
  color: var(--share-button);
  background-color: transparent;
}

.share-component__svg {
  display: flex;
  align-items: center;
  justify-content: center;
}

.share-button--xsmall {
  height: 24px;
  font-size: 12px;
  width: 79px;
  padding: 0 10px;
}

.share-button .icon {
  fill: var(--share-button);
  transition: inherit;
}

.share-button:hover {
  background-color: var(--share-button);
  border-color: var(--share-button);
  color: var(--share-button-hover);
}

.share-button:hover .icon {
  fill: var(--share-button-hover);
}

.share-button--copied {
  color: var(--share-button-copied);
  width: 132px;
  padding: 0 10px;
}

.share-button--copied:hover {
  background-color: inherit;
}

.share-button--copied .icon {
  fill: var(--success-color);
}

.share-button--xsmall.share-button--copied {
  width: 101px;
  padding: 0 4px;
}

.share-button--liveblog-meta {
  color: var(--neutral-100);
  border-color: rgba(255, 255, 255, 0.4);
}

.share-button--liveblog-meta .icon {
  fill: var(--neutral-100);
}

.share-button--liveblog-meta:not(.share-button--copied):hover {
  color: var(--share-button-liveblog-mobile-meta);
  background-color: var(--neutral-100);
  border-color: var(--neutral-100);
}

.share-button--liveblog-meta:not(.share-button--copied):hover .icon {
  fill: var(--share-button-liveblog-mobile-meta);
}

.share-button--liveblog-meta.share-button--copied .icon {
  fill: var(--success-500);
}

@media (min-width: 980px) {
  .share-button--liveblog-meta {
    color: var(--share-button);
    border-color: var(--share-button-border);
  }

  .share-button--liveblog-meta .icon {
    fill: var(--share-button);
  }

  .share-button--liveblog-meta:not(.share-button--copied):hover {
    color: var(--share-button-hover);
    background-color: var(--share-button);
    border-color: var(--share-button);
  }

  .share-button--liveblog-meta:not(.share-button--copied):hover .icon {
    fill: var(--share-button-hover);
  }
}
</style>
